import React from 'react';

const Cta = () => {
  return (
    <section className="px-4 py-20 md:px-6">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 rounded-[2.5rem] border border-amber-100/40 bg-gradient-to-r from-stone-900 via-stone-800 to-amber-900 px-8 py-12 text-center text-white shadow-2xl shadow-stone-900/20 lg:flex-row lg:px-12 lg:text-left">
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-stone-200">
            Ready to book
          </p>
          <h2 className="mt-4 font-cyclin text-4xl font-bold md:text-5xl">
            Amonthanat Massage
          </h2>
          <p className="mt-4 max-w-2xl text-lg leading-8 text-stone-200">
            Contact us directly to reserve your session. We are open every day
            from 9:00 AM to 9:00 PM.
          </p>
        </div>

        <div className="flex w-full max-w-md flex-col gap-4 sm:flex-row lg:w-auto">
          <a
            href="https://wa.me/+66641831185"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center rounded-full bg-white px-7 py-4 font-cyclin text-lg font-bold text-stone-900 transition hover:bg-stone-50"
          >
            WhatsApp
          </a>
          <a
            href="https://line.me/R/ti/p/%40886yoeiq"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center rounded-full border border-stone-300/40 px-7 py-4 text-lg font-semibold text-white transition hover:border-stone-200/60 hover:bg-white/10"
          >
            Line
          </a>
        </div>
      </div>
    </section>
  );
};

export default Cta;
